import React from "react";

import { Box, CircularProgress } from "@mui/material";

import useBrowser from "../../hooks/useBrowser";

const Loading = () => {
  const { windowHeight, windowWidth } = useBrowser();

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box padding="25px">
        <CircularProgress />
      </Box>
    </Box>
  );
};

export default Loading;
